"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuestions = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _coral_comAmazonTransFeedbackTcfaModelV = require("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1");
var _pickBy = _interopRequireDefault(require("lodash/pickBy"));
var _type = require("./type");
var _TransCustomerFeedbackAggreatorServiceClient = require("../../clients/TransCustomerFeedbackAggreatorServiceClient");
var _type2 = require("../ui/type");
var _FeedbackConstants = require("../../constants/FeedbackConstants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @typedef {{type: string, payload: any}} Action */

/**
 * Get questionnaire request action
 *
 * @param {string} applicationId
 * @param {string} feedbackIntent
 * @returns {(dispatch: Function) => Promise<Action>}
 */
var getQuestions = exports.getQuestions = function getQuestions(applicationId, feedbackIntent) {
  return function (dispatch, uiDispatch) {
    var getFeedbackQuestionnaireRequest = _coral_comAmazonTransFeedbackTcfaModelV.GetDisplayableFeedbackQuestionnaireRequest === null || _coral_comAmazonTransFeedbackTcfaModelV.GetDisplayableFeedbackQuestionnaireRequest === void 0 ? void 0 : _coral_comAmazonTransFeedbackTcfaModelV.GetDisplayableFeedbackQuestionnaireRequest.clone({
      applicationId: applicationId,
      feedbackIntent: feedbackIntent
    });
    var client = (0, _TransCustomerFeedbackAggreatorServiceClient.getTransCustomerFeedbackAggreatorServiceClient)();
    uiDispatch({
      type: _type2.IS_GET_QUESTIONS_INPROGRESS,
      payload: true
    });
    return client.getDisplayableFeedbackQuestionnaire(getFeedbackQuestionnaireRequest).toPromise().then(function (_ref) {
      var questionnaire = _ref.questionnaire,
        display = _ref.display;
      if (feedbackIntent.includes(_FeedbackConstants.CSAT_SURVEY_FEEDBACKINTENT) && !display) {
        uiDispatch({
          type: _type2.IS_SURVEY_ENABLED,
          payload: false
        });
      }
      dispatch({
        type: _type.UPDATE_QUESTIONNAIRE,
        payload: questionnaire.map(function (question) {
          return _objectSpread(_objectSpread({}, question), {}, {
            questionType: (0, _pickBy["default"])(question.questionType, function (value) {
              return value;
            })
          });
        })
      });
      uiDispatch({
        type: _type2.IS_GET_QUESTIONS_INPROGRESS,
        payload: false
      });
    })["catch"](function () {
      uiDispatch({
        type: _type2.SHOW_FAILURE_NOTIFICATION
      });
      uiDispatch({
        type: _type2.IS_GET_QUESTIONS_INPROGRESS,
        payload: false
      });
    });
  };
};
var _default = exports["default"] = {
  getQuestions: getQuestions
};
//# sourceMappingURL=index.js.map